// @flow

import React from 'react';
import moment from 'moment';
import { DateRangePicker } from 'react-dates';

type Props = {
  setDateFilter: Function,
  displayFormat: string,
  minusDays?: number,
  preventSetDateByDefault?: Boolean,
  setInitailDatesAsNull?: Boolean,
  disabled: Boolean
};

type State = {
  focusedInput: momentPropTypes.momentObj,
  startDate: momentPropTypes.momentObj,
  endDate: momentPropTypes.momentObj
};

class DateRangeFilter extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.minusDays = this.props.minusDays || 7;
    this.state = {
      focusedInput: null,
      startDate: moment()
        .subtract(this.minusDays, 'day')
        .startOf('day'),
      endDate: moment().endOf('day')
    };
    this.handleDateFilter = this.handleDateFilter.bind(this);
    this.onFocusChange = this.onFocusChange.bind(this);
  }

  componentDidMount() {
    if (this.props.setInitailDatesAsNull) {
      this.setState({
        startDate: null,
        endDate: null
      });
    }
    if (this.props.preventSetDateByDefault) {
      return;
    }

    this.setDefaultDateRange();
  }

  componentWillUnmount() {
    // Reset Date Filters to not affect table values
    this.props.setDateFilter(false, false);
  }

  onFocusChange(focusedInput?: Object) {
    this.setState({ focusedInput });
  }

  setDefaultDateRange() {
    const startDateEpoch = this.state.startDate.format('x');
    const endDateEpoch = this.state.endDate.format('x');
    this.props.setDateFilter(startDateEpoch, endDateEpoch);
  }

  handleDateFilter(startDateMomentObj?: Object, endDateMomentObj?: Object) {
    // If one of startDate or endDate is undefined(only one is selected), pass an empty string so all the rows get matched.
    if (!startDateMomentObj || !endDateMomentObj) {
      this.setState({
        startDate: startDateMomentObj,
        endDate: endDateMomentObj
      });
      if (this.props.allowedOneDateToPass) {
        let startDate = null;
        let endDate = null;
        if (startDateMomentObj) {
          startDate = startDateMomentObj.startOf('day').format('x');
        }
        if (endDateMomentObj) {
          endDate = endDateMomentObj.endOf('day').format('x');
        }
        this.props.setDateFilter(startDate, endDate);
        return;
      }
      this.props.setDateFilter(false, false);
      return;
    }

    // update store
    const selectedStartDate = startDateMomentObj.startOf('day').format('x');
    const selectedEndDate = endDateMomentObj.endOf('day').format('x');
    this.setState({
      startDate: startDateMomentObj,
      endDate: this.state.focusedInput === 'startDate' ? null : endDateMomentObj
    });
    this.props.setDateFilter(
      selectedStartDate,
      this.state.focusedInput === 'startDate' ? null : selectedEndDate
    );
  }

  render() {
    const { startDate, endDate, focusedInput } = this.state;
    const {
      disabled,
      displayFormat,
      isOutsideRangeCheck,
      isOutsideRangeCheckFunction,
      hideClearDate
    } = this.props;

    const maxEndDate = (startDate ? startDate.clone() : moment())
      .endOf('day')
      .clone()
      .add(29, 'day');
    return (
      <DateRangePicker
        minimumNights={0}
        disabled={disabled}
        readOnly
        startDate={startDate} // momentPropTypes.momentObj or null,
        endDate={endDate} // momentPropTypes.momentObj or null,
        displayFormat={displayFormat}
        onDatesChange={({ startDate: sd, endDate: ed }) =>
          this.handleDateFilter(sd, ed)
        } // PropTypes.func.isRequired,
        focusedInput={focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
        onFocusChange={fInput => this.setState({ focusedInput: fInput })} // PropTypes.func.isRequired,
        hideKeyboardShortcutsPanel={true}
        isOutsideRange={
          isOutsideRangeCheck
            ? isOutsideRangeCheckFunction
              ? day => isOutsideRangeCheckFunction(day, focusedInput, startDate)
              : day => {
                  if (focusedInput === 'endDate') {
                    // End date is not after today and not before start date
                    return (
                      day.isAfter(
                        moment(new Date(new Date().setHours(23, 59, 59, 999)))
                      ) ||
                      day.isBefore(startDate) ||
                      day.isAfter(maxEndDate)
                    );
                  }
                  if (focusedInput === 'startDate') {
                    // Start date is not after today and not after end date and not before 31 days ago.
                    return day.isAfter(moment(new Date()));
                  }

                  return false;
                }
            : () => false
        }
        showClearDates={hideClearDate !== true}
      />
    );
  }
}

export default DateRangeFilter;
